import { default as Image } from '@react/shared/components/Image';
import { assetPath } from 'sly/lib/path';
import { eventNames, useEvents } from 'sly/services/events';

const medias = [
  {
    src: assetPath(
      'uploads/react-assets/providers/9d05bc137a5414038f88e4273d647bef.jpeg'
    ),
    alt: 'Senior Living Advisors',
    title: 'For senior living advisors',
    description: `Whether you're new to the industry or an experienced advisor ready for growth, we've got solutions to help you take the next step.`,
    threePoints: [],
    href: '/partners/senior-living-advisors',
    text: 'Learn more',
  },
  {
    src: assetPath(
      'uploads/react-assets/providers/cc2885c497a116e7ff8fa3fe8387dffa.png'
    ),
    alt: 'Seniorly Adjacent Industries',
    title: 'For senior adjacent industries',
    description:
      'Improve service delivery for clients and drive revenue with a tech-driven partner that will change how you work with older adults.',
    threePoints: [],
    href: '/partners/senior-adjacent-industries',
    text: 'Learn more',
  },
  {
    src: assetPath(
      'uploads/react-assets/providers/1e378dee8fae2e889fb47d51b0cd4cd7.png'
    ),
    alt: 'Providers',
    title: 'For providers',
    description:
      'Build census with the only tech-driven referral partner built for the way today’s families search.',
    threePoints: [],
    href: '/partners/communities',
    text: 'Learn more',
  },
];

export default function PartnersCommunitiesSectionsOverview() {
  const { events } = useEvents();
  const handleClick = (page: string, text: string) => {
    if (location)
      events.track(eventNames.ButtonClicked, {
        text,
        location: 'B2B provider page',
      });
    window.open(page, '_blank');
  };
  return (
    <main className='flex flex-col items-center gap-8 px-6 py-12 lg:gap-12 lg:py-20 lg:px-12'>
      <section className='flex max-w-5xl flex-wrap content-center items-center justify-center gap-6 self-stretch md:self-center'>
        <div className='flex flex-1 flex-col items-start gap-2.5 md:w-[600px]'>
          <div className='flex flex-col items-center gap-4 self-stretch'>
            <h2 className='font-t-xl self-stretch text-center'>
              Custom senior living solutions designed for your needs
            </h2>
            <p className='font-b-m  self-stretch text-center'>
              Our tools and platforms empower you to guide your clients
              seamlessly through senior living discovery, while unlocking new
              revenue streams for your business.
            </p>
          </div>
        </div>
      </section>

      <section className='flex w-full max-w-7xl flex-col gap-12 self-stretch lg:flex-row lg:justify-center lg:self-auto'>
        {medias.map((section, index) => (
          <section
            className='flex w-full flex-col items-start gap-6 self-stretch lg:gap-12 lg:self-auto'
            key={index}
          >
            <div className='flex flex-col items-start gap-6 self-stretch lg:flex-1 lg:self-auto'>
              <span className='relative h-full self-stretch rounded-xl md:h-80 lg:w-auto'>
                <Image
                  src={section.src}
                  alt={section.alt}
                  layout='raw'
                  objectFit='cover'
                  className='h-full w-full rounded-xl object-cover'
                  width={400}
                  height={400}
                ></Image>
              </span>

              <section className='flex flex-col items-start gap-6 rounded-2xl'>
                <div className='flex flex-col items-start gap-4'>
                  <h6 className='font-t-m'>{section.title}</h6>
                  <p>
                    <span className='font-b-m'>{section.description}</span>
                  </p>
                </div>

                {!!section?.threePoints?.length && (
                  <section className='flex flex-col items-start gap-4 self-stretch'>
                    {section?.threePoints?.map((point, index) => (
                      <div
                        key={index}
                        className='flex items-start gap-4 self-stretch'
                      >
                        <span className='flex items-start gap-2 rounded-full bg-green-lighter-90 p-1'>
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                          >
                            <path
                              d='M9.55119 14.9475L17.9186 6.58013C18.1465 6.35223 18.4169 6.23828 18.7297 6.23828C19.0426 6.23828 19.313 6.35223 19.5409 6.58013C19.7688 6.80803 19.8827 7.07841 19.8827 7.39128C19.8827 7.70413 19.7688 7.97451 19.5409 8.20241L10.3528 17.3905C10.1249 17.6184 9.8577 17.7323 9.55119 17.7323C9.24467 17.7323 8.97746 17.6184 8.74956 17.3905L4.46151 13.1024C4.23361 12.8745 4.12283 12.6041 4.12916 12.2913C4.13551 11.9784 4.25264 11.708 4.48054 11.4801C4.70844 11.2522 4.97882 11.1383 5.29169 11.1383C5.60454 11.1383 5.87491 11.2522 6.10281 11.4801L9.55119 14.9475Z'
                              fill='#339F43'
                            />
                          </svg>
                        </span>
                        <span className='font-b-m'>{point}</span>
                      </div>
                    ))}
                  </section>
                )}
                <button
                  className='flex items-start justify-center gap-2 self-stretch rounded-lg border border-viridian-base p-3 md:self-auto'
                  onClick={() => handleClick(section.href, section.text)}
                >
                  <p className='font-t-xs-azo text-viridian-base'>Learn more</p>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    viewBox='0 0 24 24'
                    fill='none'
                  >
                    <path
                      d='M16.0885 12.8992L5.17659 12.8992C4.85737 12.8992 4.58798 12.7895 4.36841 12.5699C4.14885 12.3503 4.03906 12.0809 4.03906 11.7617C4.03906 11.4425 4.14885 11.1732 4.36841 10.9536C4.58798 10.734 4.85737 10.6242 5.17659 10.6242L16.0885 10.6242L11.4217 5.95739C11.1938 5.72949 11.083 5.46228 11.0893 5.15576C11.0957 4.84924 11.2128 4.58204 11.4407 4.35414C11.6686 4.1429 11.9358 4.03411 12.2423 4.02776C12.5489 4.02143 12.8161 4.13221 13.044 4.36011L19.644 10.9601C19.7559 11.0721 19.8377 11.1963 19.8894 11.3329C19.941 11.4695 19.9668 11.6125 19.9668 11.7617C19.9668 11.911 19.941 12.054 19.8894 12.1905C19.8377 12.3271 19.7559 12.4514 19.644 12.5634L13.038 19.1693C12.8228 19.3846 12.5597 19.4922 12.2489 19.4922C11.938 19.4922 11.6686 19.3846 11.4407 19.1693C11.2128 18.9414 11.0989 18.6711 11.0989 18.3582C11.0989 18.0453 11.2128 17.775 11.4407 17.5471L16.0885 12.8992Z'
                      fill='#1A7473'
                    />
                  </svg>
                </button>
              </section>
            </div>
          </section>
        ))}
      </section>
    </main>
  );
}
